import { combineReducers } from 'redux';

// general or pending
import flashReducer from './flash';
import modalReducer from './modal';
import appLoadingReducer from './appLoading';
// secondaryModal reducer removed - migrated to Zustand store
import localeReducer from './locale';
import languageReducer from './language';
// plan, course, lecture reducers removed - migrated to TanStack Query
import onlineStatusReducer from './onlineStatus';
import timeZoneReducer from './timeZone';
import conversationReducer from './conversation';
import messageReducer from './message';

// Related with current user.
import authReducer from './me/auth';
import bookingReducer from './me/booking';
import geoDataReducer from './me/geoData';
import lessonReducer from './me/lesson';
import lessonWithIssueReducer from './me/lessonWithIssue';
import lessonIssueReducer from './me/lessonIssue';
// notificationSetting reducer removed - migrated to TanStack Query
import paymentReducer from './me/payment';
import paymentMethodReducer from './me/paymentMethod';
import placementReducer from './me/placement';
import pronunciationReducer from './me/pronunciation';
import unseenMessageCountReducer from './me/unseenMessageCount';
// education, certification, interest reducers removed - migrated to TanStack Query
// tutorBankInfo, tutorBalanceTransaction, tutorHourlyRate reducers removed - dead code
import tutorIssueRateReducer from './me/tutorIssueRate';
import tutorSubscribeRateReducer from './me/tutorSubscribeRate';
import tutorShiftSetReducer from './me/tutorShiftSet';
import tutorShiftReducer from './me/tutorShift';
import tutorScheduleReducer from './me/tutorSchedule';
// billingHistory reducer removed - migrated to TanStack Query
// slotAvailability reducer removed - migrated to TanStack Query

// When current user is a tutor and need student related data.
import studentLessonReducer from './student/lesson';
import studentLessonSummaryReducer from './student/lessonSummary';
import studentPlacementReducer from './student/placement';
import studentPronunciationReducer from './student/pronunciation';
import studentDataReducer from './student/data';
// import studentBookingReducer from './student/booking';

// When current user is a student and need tutor related data.
import tutorTimeslotReducer from './tutor/timeslotStatus';
import tuotrListTimeslotReducer from './tutor/tutorListTimeslotStatus';
import tutorReducer from './tutor/tutor';
import tutorDataReducer from './tutor/data';
import tutorLessonReviewReducer from './tutor/lessonReview';
// tutorInterest, tutorEducation, tutorsCertification reducers removed - migrated to TanStack Query
import tutorsOnSlotReducer from './tutor/tutorsOnSlot';

const rootReducer = combineReducers({
  // general
  flash: flashReducer,
  appLoading: appLoadingReducer,
  modal: modalReducer,
  locale: localeReducer,
  language: languageReducer,
  onlineStatus: onlineStatusReducer,
  timeZone: timeZoneReducer,
  conversation: conversationReducer,
  message: messageReducer,

  // me
  auth: authReducer,
  booking: bookingReducer,
  lesson: lessonReducer,
  lessonWithIssue: lessonWithIssueReducer,
  lessonIssue: lessonIssueReducer,
  geoData: geoDataReducer,
  placement: placementReducer,
  // interest, education, certification reducers removed - migrated to TanStack Query
  tutorIssueRate: tutorIssueRateReducer,
  tutorSubscribeRate: tutorSubscribeRateReducer,
  payment: paymentReducer,
  paymentMethod: paymentMethodReducer,
  pronunciation: pronunciationReducer,
  unseenMessageCount: unseenMessageCountReducer,
  tutorShiftSet: tutorShiftSetReducer,
  tutorShift: tutorShiftReducer,
  tutorSchedule: tutorScheduleReducer,

  // student
  studentPronunciation: studentPronunciationReducer,
  studentPlacement: studentPlacementReducer,
  studentLesson: studentLessonReducer,
  studentLessonSummary: studentLessonSummaryReducer,
  studentData: studentDataReducer,

  // tutor
  tutor: tutorReducer,
  tutorData: tutorDataReducer,
  tutorTimeslot: tutorTimeslotReducer,
  tutorListTimeslot: tuotrListTimeslotReducer,
  tutorLessonReview: tutorLessonReviewReducer,
  // tutorInterest, tutorEducation, tutorsCertification removed - migrated to TanStack Query
  tutorsOnSlot: tutorsOnSlotReducer,
});

export default rootReducer;
